import { useTranslation } from 'react-i18next';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

/**
 * EN/ES language switcher. i18next (backed by localStorage) is the single
 * source of truth — this component holds no state of its own.
 */
export function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const active = i18n.resolvedLanguage === 'es' ? 'es' : 'en';

  return (
    <ToggleGroup
      type="single"
      size="sm"
      value={active}
      aria-label={t('common.language')}
      onValueChange={(value) => {
        if (value) i18n.changeLanguage(value);
      }}
    >
      <ToggleGroupItem value="en" aria-label="English" className="px-2 text-xs">
        EN
      </ToggleGroupItem>
      <ToggleGroupItem value="es" aria-label="Español" className="px-2 text-xs">
        ES
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
